import { Trans } from "react-i18next";
import { Caption } from "src/atoms/typography";
import { getLocale } from "src/utils/locale";
import openExternal from "src/utils/openExternal";

export default function TermsAndPrivacyPolicy() {
  return (
    <Caption
      textAlign="center"
      color="mediumEmphasis"
      sx={{
        span: {
          textDecoration: "underline",
          cursor: "pointer"
        }
      }}
    >
      <Trans i18nKey="wizard.termsAndPrivacyPolicy">
        By using our app, you agree to our
        <span onClick={() => openExternal({ env: "TERMS_OF_SERVICE_URL" })}>
          Terms of Service
        </span>
        and
        <span
          onClick={() =>
            openExternal({
              env:
                getLocale().split("-")[0] === "de"
                  ? "GERMAN_PRIVACY_POLICY_URL"
                  : "PRIVACY_POLICY_URL"
            })
          }
        >
          Privacy Policy
        </span>
        .
      </Trans>
    </Caption>
  );
}
